import React from 'react';
import { useSelector } from 'react-redux';
import { Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { BlockOutlined, UnorderedListOutlined } from '@ant-design/icons';

import { safeExtractFromObject } from '../../helpers/helpers';
import OnTraccrSwitch from '../inputs/OnTraccrSwitch';

export default function CardGridListViewSwitch({
  isListView = false,
  onViewTypeChanged,
}) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const hasRedesign = settings?.uxRedesignPt1;
  if (!hasRedesign) {
    return (
      <OnTraccrSwitch
        value={isListView}
        onChange={onViewTypeChanged}
        style={{ marginLeft: 5 }}
        title={`${isListView ? 'List' : 'Card'} View`}
      />
    );
  }

  const getClass = (item) => (
    item === isListView
      ? 'card-grid-list-view-switch-item-active'
      : 'card-grid-list-view-switch-item'
  );

  return (
    <div className="card-grid-list-view-switch">
      <Tooltip title="List View">
        <div className={getClass(true)} onClick={() => onViewTypeChanged(true)}>
          <UnorderedListOutlined className="card-grid-list-view-switch-item-icon" />
        </div>
      </Tooltip>
      <Tooltip title="Block View">
        <div className={getClass(false)} onClick={() => onViewTypeChanged(false)}>
          <BlockOutlined className="card-grid-list-view-switch-item-icon" />
        </div>
      </Tooltip>
    </div>
  );
}

CardGridListViewSwitch.propTypes = {
  isListView: PropTypes.bool,
  onViewTypeChanged: PropTypes.func,
};

CardGridListViewSwitch.defaultProps = {
  isListView: false,
  onViewTypeChanged: () => {},
};
